import type { ListView } from '@/components/list/ViewTabs';
import { ALL_PERIODS } from './list-query';

/** The labels of the system views, already translated. */
export interface SystemViewLabels {
  readonly mine: string;
  readonly noDocument: string;
  readonly companyCard: string;
  readonly refused: string;
}

/**
 * The expense list's system views (decision 182, U6): the same for everyone, as URL presets the
 * API already answers. «Non ancora in una nota spese» waits for round 2 (no report filter yet).
 * A view names the filters it sets; the ones it does not name are cleared when it is chosen.
 *
 * - «Le mie spese di questo mese»: this month, the caller's own. `ownerId` is the caller's id; it
 *   is named only for a role that may filter by owner (anyone else sees only their own anyway).
 * - The others look across every period, for the role's scope: own for a submitter, all for the
 *   administrators.
 */
export function systemViews(
  labels: SystemViewLabels,
  options: { readonly currentMonth: string; readonly ownerId: string | null },
): ListView[] {
  const mine: Record<string, string> = { period: options.currentMonth };
  if (options.ownerId !== null) mine['owner'] = options.ownerId;
  return [
    { id: 'mine', label: labels.mine, params: mine },
    {
      id: 'no-document',
      label: labels.noDocument,
      params: { period: ALL_PERIODS, document: 'awaited' },
    },
    {
      id: 'company-card',
      label: labels.companyCard,
      params: { period: ALL_PERIODS, payer: 'company-card' },
    },
    { id: 'refused', label: labels.refused, params: { period: ALL_PERIODS, status: 'refused' } },
  ];
}
